import { useEffect, useState } from "react";
import { Anchor } from "lucide-react";


const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`scroll-top-btn ${showButton ? "show" : ""}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <Anchor size={20} strokeWidth={2.2} />
    </button>
  );
};

export default ScrollToTopButton;